import React from "react";
import { Custom, Form, Progress } from "components";
import { useApp } from "context";
import { IPatient } from "interfaces";
import { Store } from "utils";

type Props = {
  sx?: any;
  opened: boolean;
  patient?: IPatient | null;
  patientId?: number | null;
  onClose?: () => void;
};

export const Profile = (props: Props) => {
  const { t, theme, service } = useApp();
  const [patient, setPatient] = React.useState<IPatient | null>(null);

  const isClinic = Store.sessionStorage.isClinic();

  React.useEffect(() => {
    const fetchData = async () => {
      if (props.patientId) {
        const response = await service.patient.find(props.patientId);
        setPatient(response[0]);
      } else if (!props.patient) {
        const response = await service.patient.find();
        setPatient(response);
      } else {
        setPatient(props.patient);
      }
    };
    fetchData();
  }, [props.opened]);

  return (
    <>
      <Custom.Modal
        header={t.title.profile}
        opened={props.opened}
        onClose={props.onClose}
        sx={{ maxHeight: "min(800px, 100vh)" }}
      >
        {patient ? (
          <>
            <Form.Profile
              patient={patient}
              isClinic={isClinic}
              onSubmit={props.onClose}
            />
          </>
        ) : (
          <Progress.PageProcess />
        )}
      </Custom.Modal>
    </>
  );
};
